'use strict';

angular.module('taskController', [])

.controller('TaskController', ['appInfo','$scope', '$rootScope', '$log', '$q', '$location', '$routeParams', '$filter',
    function (appInfo, $scope, $rootScope, $log, $q, $location, $routeParams, $filter) {    
    
    //Check auth credentials
    var currentUser = $rootScope.currentUser
    , ekey = currentUser.authdata
    , name = currentUser.name
    , ttl = 0
    , rankTotal = 0
    , priceTotal = 0
    , feedback = 0
    , agent
    ;

    $rootScope.header.style = "collapse";
    $rootScope.header.show = false;

    $scope.task = {};
    $scope.task.id = ($routeParams.id)? $routeParams.id : 0;

    
    $scope.getTask = function (taskId) {
        $rootScope.loading = true; 
        
        for(var i = 0; i < $rootScope.currentListing.data.appointments.length; i++){
            if($rootScope.currentListing.data.appointments[i].taskRef == taskId){
                var agent = {};

                for (var key in $rootScope.currentListing.data.appointments[i].agent.info) {
                  if ($rootScope.currentListing.data.appointments[i].agent.info.hasOwnProperty(key)) {

                    switch(key){
                        case 'photo':
                            agent.photo = $rootScope.currentListing.data.appointments[i].agent.info[key];
                            break;
                        case 'email':
                            agent.email = $rootScope.currentListing.data.appointments[i].agent.info[key];
                            break;
                        case 'phone_-_mobile':
                            agent.mobile = $rootScope.currentListing.data.appointments[i].agent.info[key];
                            break;
                        case 'facebook':
                            agent.facebook = $rootScope.currentListing.data.appointments[i].agent.info[key];
                            break;
                    }
                  }
                }

                $rootScope.currentListing.data.appointments[i].agent.info = agent;
                $scope.task.label   = $rootScope.currentListing.data.appointments[i].label;
                $scope.task.cls     = $rootScope.currentListing.data.appointments[i].cls;
                $scope.task.string  = $rootScope.currentListing.data.appointments[i].str;
                $scope.task.agent   = $rootScope.currentListing.data.appointments[i].agent;
                $scope.task.feedback= $rootScope.currentListing.data.appointments[i].feedback;

                angular.forEach($scope.task.feedback, function(fb) {
                    ttl ++;

                    fb.maskedBuyer = 'Buyer ('+fb.feedbackRef+')';
                    
                    if(parseInt(fb.priceOpinion) !== 9999999) {
                        priceTotal += parseInt(fb.priceOpinion);
                        feedback ++;
                    }

                    rankTotal += fb.rate;

                });

                $scope.task.avg = Math.ceil(priceTotal/feedback);
                $scope.task.rank = Math.ceil(rankTotal/ttl);           
            }
        }

        $rootScope.loading = false; //End Spinner
    };

    $scope.fliterAppointments = function (tr) {
        $rootScope.currentListing.tasks = $filter('tasksPending')($rootScope.currentListing.data.appointments, tr);
        $rootScope.currentListing.showArchived = (tr == 'new')? true : false;
    }

    $scope.showEvent = function (ref) {
        $location.path('/activity/event/'+ref);
    };

    $scope.back2tasks = function () {
        $location.path('/activity');
    };

    $scope.loadTasks = function (){
        //Start spinner
        $rootScope.loading = true;

        if(typeof $rootScope.currentListing.tasks == 'undefined') {
            $scope.fliterAppointments('new');
        }

        //Stop spinner
        $rootScope.loading = false;
    };

}]);